import React from 'react';
import { Box } from '@mui/material';
import ChatMessage from './ChatMessage';
import ReasoningSection from './ReasoningSection';

const MessageList = ({
  messages = [],
  theme,
  mergedAllMessages = [],
  streamingToolOrder = [],
  streamingToolMap = {},
  turnReasoningSections = [],
  onOpenReport,
  compactLayout = false,
  onToggleReasoningSection,
  onFollowUps,
  onClickFollowUp,
  isFullscreen = false
}) => {
  return (
    <>
      {messages.map((message) => {
        const afterUserId = message.type === 'user' ? message.id : null;
        const attached = afterUserId ? turnReasoningSections.filter((s) => s.afterMessageId === afterUserId) : [];
        return (
          <React.Fragment key={message.id}>
            <ChatMessage
              message={message}
              theme={theme}
              onOpenReport={onOpenReport}
              allMessages={mergedAllMessages}
              liveToolStates={{ order: streamingToolOrder, map: streamingToolMap }}
              compactLayout={compactLayout}
              onFollowUps={onFollowUps}
              onClickFollowUp={onClickFollowUp}
              isFullscreen={isFullscreen}
            />
            {attached.map((section) => (
              <ReasoningSection
                key={section.id}
                section={section}
                theme={theme}
                onToggle={(id) => onToggleReasoningSection && onToggleReasoningSection(id)}
              />
            ))}
          </React.Fragment>
        );
      })}
      <Box component="div" />
    </>
  );
};

export default MessageList;
